import { PageTitle } from "Components/Titles";
import { Container } from "semantic-ui-react";
import { CreateAccount } from "Features/Account";
import { useTranslation } from "react-i18next";

function NewAccount () {

    const { t } = useTranslation();

    return (
        <Container className="page">
            <PageTitle title={t("pages.newAccount")} />
            <CreateAccount />
        </Container>
    );
}

export default NewAccount;